import { IState } from '../../store';
import { EBookingStatus } from '../../types/newbuildingBooking';

export const selectIsBookingError = (state: IState): boolean => {
  return state.newbuildingBooking.status === EBookingStatus.Failure;
};
